<template>
  <input
      bind:this={inserimento}
      type="number"
      name={nome}
      placeholder={segnaposto}
      disabled={disabilitato}
      aria-label={attributi.etichetta}
      min={attributi.minimo}
      max={attributi.massimo}
      autocomplete={autocompletamento}
      maxlength={lunghezza_massima}
      step={passo}
      bind:value={valore}
      on:keydown
      on:input
      on:focus
      on:blur/>
</template>

<script>

  import { onMount } from "svelte";

  export let nome = ""
  export let valore = ""
  export let segnaposto = ""
  export let disabilitato = false
  export let attributi = {}
  export let lunghezza_massima = null
  export let passo = 1
  export let disabilita_scroll_numero = false

  let inserimento = null

  let autocompletamento = attributi.autocompletamento == false ? "off" : attributi.autocompletamento || "on"

  $: if (attributi.min != null && valore < attributi.min) valore = null
  $: if (attributi.max != null && valore > attributi.max) valore = attributi.max

  ////
  // Blocca lo scroll sul campo quando è attivo.
  function blocca_scroll_numero() {
    if (!disabilita_scroll_numero) return
    if (document.activeElement !== inserimento) return
    document.activeElement.blur()
  }

  ////
  // Esegue il controllo dello scroll sul campo.
  onMount (() => {
    document.addEventListener("wheel", blocca_scroll_numero)
    return () => document.removeEventListener("wheel", blocca_scroll_numero)
  })

  // Per compatibilità con altri inserimenti.
  attributi
</script>
